export default {"src":"/_next/static/media/UBER.ee7ce719.svg","height":18,"width":18};